<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kunde bearbeiten') }}</h1>
        </div>

        <form @submit.prevent="form.put(route('admin.customers.update', customer))">
            <form-fields
                :form="form"
                :customer="customer" 
                :countries="countries"
                :customer-groups="customerGroups" 
                />
        </form>

        <hr />

        <div class="d-flex justify-content-between">
            <div class="mb-4">
                <inertia-link :href="route('admin.users.create', {account_id: customer.id})" class="btn btn-outline-primary">
                    {{ __('Benutzer erstellen') }}
                </inertia-link>
            </div>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'customer',
            'countries',
            'customerGroups',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.customer.name,
                    account_type: this.customer.account_type,
                    customer_group_id: this.customer.customer_group_id,
                    customer_number: this.customer.customer_number,
                    slug: this.customer.slug,
                    logo: this.customer.logo,
                    short_name: this.customer.short_name,
                    street: this.customer.street,
                    house_number: this.customer.house_number,
                    zip_code: this.customer.zip_code,
                    city: this.customer.city,
                    country_id: this.customer.country_id,
                    default_category_id: this.customer.default_category_id,
                    phone: this.customer.phone,
                    fax: this.customer.fax,
                    email: this.customer.email,
                    vat_id: this.customer.vat_id,
                    website: this.customer.website,
                    description: this.customer.description,
                    notes: this.customer.notes,
                }),
                columns: {
                    id: {label: 'ID'},
                    name: {label: 'Name'},
                    email: {label: 'Email'},
                    notes: {label: 'Notes'},
                },
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>